import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export const ApiEpBillingCurrentPlansubscription = {
    retrieve: () => apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/current-plansubscription`,
        method: "GET",
    }),
};
//# sourceMappingURL=current_plansubscription.js.map